import ServiceRestApi from "./service-rest-api";

class ClientService {

    cacheUtility = {};

    //GET CUSTOMER INFORMATIONS
    getClientInfo = (clientId) => {
        return ServiceRestApi.get(`/api/client?client-id=${clientId}`);
    }

    //PATCH CLIENT INFOROMATIONS
    updateClient = (payload) => {
        return ServiceRestApi.patch(`/api/client`, payload);
    }

    //GET CLIENT HISTORY
    getClientHistory = (clientId, pageIndex, pageSize = 30) => {
        return ServiceRestApi.get(`/api/interventions?view=history&clientId=${clientId}&page-size=${pageSize}&page-index=${pageIndex}&sort=DESC`);
    }

    //SYNCHRONIZE CLIENT INFORMATIONS
    refreshClientInfo = (clientId, sourceId) => {
        return ServiceRestApi.patch(`/api/synchronise-client?client-id=${clientId}&source-id=${sourceId}`)
    }

    //GET WILAYAS
    getWilayas = () => {
        let suffix = `/api/wilayas`;
        if (!this.cacheUtility[suffix]) this.cacheUtility[suffix] = ServiceRestApi.get(suffix);
        return this.cacheUtility[suffix];
    }

    //GET COMMUNES
    getCommunes = (wilayaId) => {
        return wilayaId ? ServiceRestApi.get(`/api/communes?wilayaId=${wilayaId}`) : Promise.resolve({ result: [] });
    }

}
export default new ClientService();